module.exports = __webpack_public_path__ + "static/img/sign.685bea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sign.png
// module id = hDw7
// module chunks = 1